import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/896548c3-0c25-43e8-8d49-8382242f1985";
export const REGISTER_URL = "https://a.ntrk2.com/4b0818d4-facd-44da-bf78-ae692282122a";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://top268.loadprkw2a.com/download?openExternalBrowser=1&id=at7h3mbzph3zy8u";

export * from "./codes";
export * from "./context";
